module.exports = __webpack_public_path__ + "static/media/screen4.70ccb854.jpg";